(() => {
const svRoot = document.getElementById('sv-seven-lives-landing');
if (!svRoot) return;
svRoot.querySelector('#sv-yr').textContent=new Date().getFullYear();

/* language toggle */
function setLang(l){
  svRoot.dataset.lang=l;
  svRoot.querySelectorAll('[data-es]').forEach(e=>{const v=e.getAttribute('data-'+l);if(v!==null)e.textContent=v;});
  svRoot.querySelectorAll('[data-es-html]').forEach(e=>{const v=e.getAttribute('data-'+l+'-html');if(v!==null)e.innerHTML=v;});
  svRoot.querySelectorAll('.sv-lang-opt').forEach(b=>b.classList.toggle('sv-active',b.dataset.lang===l));
}
svRoot.querySelectorAll('.sv-lang-opt').forEach(b=>b.addEventListener('click',()=>setLang(b.dataset.lang)));

/* mobile menu */
const burger=svRoot.querySelector('#sv-burger'),mm=svRoot.querySelector('#sv-mobileMenu');
burger.addEventListener('click',()=>mm.classList.toggle('open'));
mm.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>mm.classList.remove('open')));

/* scroll reveal (con stagger para grupos) */
const staggerGroups=['.sv-pillars','.sv-svc-grid'];
const io=new IntersectionObserver((es)=>{es.forEach(e=>{
  if(!e.isIntersecting)return;
  const el=e.target,par=el.parentElement;
  let d=0;
  if(par&&staggerGroups.some(s=>par.matches(s))) d=[...par.children].indexOf(el)*110;
  setTimeout(()=>el.classList.add('sv-in'),d);
  io.unobserve(el);
});},{threshold:.14,rootMargin:'0px 0px -6% 0px'});
svRoot.querySelectorAll('.sv-reveal').forEach(el=>io.observe(el));
window.addEventListener('load',()=>setTimeout(()=>svRoot.querySelectorAll('.sv-reveal:not(.sv-in)').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<innerHeight*1.1)el.classList.add('sv-in');}),400));

/* nav shadow */
const nav=svRoot.querySelector('.sv-nav');
addEventListener('scroll',()=>nav.classList.toggle('scrolled',scrollY>8),{passive:true});

/* scrollspy (por posición de scroll) */
const spyLinks=[...svRoot.querySelectorAll('.sv-nav-links a[href^="#"]')].filter(a=>a.getAttribute('href').length>1);
const spySecs=spyLinks.map(a=>document.getElementById(a.getAttribute('href').slice(1))).filter(Boolean);
const spyUpd=()=>{
  const y=scrollY+innerHeight*0.35;
  let cur=null;
  spySecs.forEach(s=>{if(s.offsetTop<=y)cur=s.id;});
  spyLinks.forEach(l=>l.classList.toggle('sv-active',l.getAttribute('href')==='#'+cur));
};
addEventListener('scroll',spyUpd,{passive:true});spyUpd();

/* carrusel: flechas */
const gt=svRoot.querySelector('.sv-gtrack');
if(gt){
  const prev=svRoot.querySelector('.sv-garrow.sv-prev'),next=svRoot.querySelector('.sv-garrow.sv-next');
  const step=()=> (gt.querySelector('.sv-gcard')?.getBoundingClientRect().width||360)+22;
  const upd=()=>{prev.toggleAttribute('disabled',gt.scrollLeft<10);
    next.toggleAttribute('disabled',gt.scrollLeft>gt.scrollWidth-gt.clientWidth-10);};
  prev.addEventListener('click',()=>gt.scrollBy({left:-step(),behavior:'smooth'}));
  next.addEventListener('click',()=>gt.scrollBy({left:step(),behavior:'smooth'}));
  gt.addEventListener('scroll',upd,{passive:true}); upd();
}

/* 10% count-up al revelar */
const big=svRoot.querySelector('.sv-alliance-sec .sv-big');
if(big){
  const cio=new IntersectionObserver(es=>{es.forEach(e=>{
    if(!e.isIntersecting)return; cio.disconnect();
    const t0=performance.now(),D=900;
    const iv=setInterval(()=>{
      const p=Math.min(1,(performance.now()-t0)/D);
      big.textContent=Math.round(10*(1-Math.pow(1-p,3)))+'%';
      if(p>=1)clearInterval(iv);
    },40);
  });},{threshold:.4});
  cio.observe(big);
}

/* barra CTA móvil */
const bar=svRoot.querySelector('#sv-stickyCta'),hero=svRoot.querySelector('#sv-inicio'),
      compra=svRoot.querySelector('#sv-compra'),foot=svRoot.querySelector('.sv-footer');
const barUpd=()=>{
  const cb=compra.getBoundingClientRect(),fb=foot.getBoundingClientRect();
  bar.classList.toggle('show',
    scrollY>hero.offsetHeight*0.7 && cb.top>innerHeight-120 && fb.top>innerHeight);
};
addEventListener('scroll',barUpd,{passive:true});barUpd();

/* Compra Shopify: los CTA llevan al selector; el formulario agrega la cantidad elegida y abre el checkout. */
const productForm=svRoot.querySelector('.sv-product-form');
const directBuyButtons=[...svRoot.querySelectorAll('[data-sv-buy]')];

if(productForm){
  const buyButton=productForm.querySelector('[type="submit"]');
  const productError=productForm.querySelector('.sv-product-error');
  const quantityInput=productForm.elements.quantity;
  const clampQuantity=value=>Math.max(1,Math.min(99,parseInt(value,10)||1));

  productForm.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{
    quantityInput.value=clampQuantity(Number(quantityInput.value)+Number(button.dataset.quantityStep));
    quantityInput.dispatchEvent(new Event('change',{bubbles:true}));
  }));
  quantityInput.addEventListener('change',()=>{quantityInput.value=clampQuantity(quantityInput.value);});

  const buyNow=async trigger=>{
    if(trigger.dataset.svBusy==='true'||buyButton.disabled)return;

    const quantity=clampQuantity(quantityInput.value);
    quantityInput.value=quantity;
    const originalText=trigger.textContent;
    trigger.dataset.svBusy='true';
    trigger.setAttribute('aria-busy','true');
    trigger.setAttribute('aria-disabled','true');
    if(trigger===buyButton)buyButton.disabled=true;
    trigger.textContent=svRoot.dataset.lang==='en'?'Processing…':'Procesando…';
    productError.hidden=true;

    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{
        method:'POST',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:new FormData(productForm)
      });
      const result=await response.json().catch(()=>({}));

      if(!response.ok){
        const error=new Error(result.description||result.message||'Product unavailable');
        error.status=response.status;
        throw error;
      }

      const requestedVariant=productForm.elements.id.value;
      if(String(result.id)!==String(requestedVariant))throw new Error('Unexpected variant added');

      window.location.assign('/checkout');
    }catch(error){
      const lang=svRoot.dataset.lang;
      productError.textContent=error.status===422
        ?(lang==='en'?'Product or requested quantity unavailable':'Producto o cantidad no disponible')
        :(lang==='en'?'Could not add the product. Try again.':'No se pudo agregar el producto. Intenta de nuevo.');
      productError.hidden=false;
      trigger.textContent=originalText;
      trigger.removeAttribute('aria-busy');
      trigger.removeAttribute('aria-disabled');
      delete trigger.dataset.svBusy;
      if(trigger===buyButton)buyButton.disabled=false;
      svRoot.querySelector('#sv-compra').scrollIntoView({behavior:'smooth',block:'center'});
    }
  };

  productForm.addEventListener('submit',event=>{
    event.preventDefault();
    buyNow(buyButton);
  });

  directBuyButtons.forEach(button=>button.addEventListener('click',event=>{
    event.preventDefault();
    mm.classList.remove('open');
    quantityInput.scrollIntoView({behavior:'smooth',block:'center'});
    setTimeout(()=>quantityInput.focus({preventScroll:true}),500);
  }));
}else{
  directBuyButtons.forEach(button=>button.addEventListener('click',event=>{
    event.preventDefault();
    svRoot.querySelector('#sv-compra').scrollIntoView({behavior:'smooth',block:'center'});
  }));
}

/* AUDIO — coloca tus archivos en una carpeta /audio junto a este HTML:
   audio/mirla.mp3, audio/frailejon.mp3, audio/colibri.mp3, audio/zorro.mp3,
   audio/rana.mp3, audio/oso.mp3, audio/fara.mp3 */
let current=null;
svRoot.querySelectorAll('.sv-audio').forEach(btn=>{
  const src=btn.dataset.audio,label=btn.querySelector('.sv-audio-label');
  const orig=()=>label.getAttribute('data-'+svRoot.dataset.lang)||label.textContent;
  let audio=null,base=null;
  btn.addEventListener('click',()=>{
    if(!src){label.textContent=(svRoot.dataset.lang==='en'?'Audio coming soon':'Audio próximamente');setTimeout(()=>setLang(svRoot.dataset.lang),2200);return;}
    base=label.textContent;
    if(!audio){
      audio=new Audio(src);
      audio.addEventListener('ended',()=>{btn.classList.remove('playing');btn.classList.add('paused');setLang(svRoot.dataset.lang);});
      audio.addEventListener('error',()=>{btn.classList.remove('playing');label.textContent=(svRoot.dataset.lang==='en'?'Audio coming soon':'Audio próximamente');setTimeout(()=>setLang(svRoot.dataset.lang),2200);});
    }
    if(audio.paused){ if(current&&current!==audio)current.pause(); current=audio;
      audio.play().then(()=>{btn.classList.remove('paused');btn.classList.add('playing');label.textContent=(svRoot.dataset.lang==='en'?'Playing…':'Reproduciendo…');}).catch(()=>{});
    } else { audio.pause();btn.classList.remove('playing');setLang(svRoot.dataset.lang); }
  });
});

/* slideshows automáticos: galería (acuarela <-> foto del pin) y libro */
function autoSlides(selector,interval){
  svRoot.querySelectorAll(selector).forEach((group,groupIndex)=>{
    const slides=group.querySelectorAll('.sv-gslide, .sv-bslide');
    if(slides.length<2)return;
    let index=0;
    setInterval(()=>{
      slides[index].classList.remove('sv-active');
      index=(index+1)%slides.length;
      slides[index].classList.add('sv-active');
    },interval+groupIndex*260);
  });
}
autoSlides('.sv-gimg.sv-gslides',3200);
autoSlides('.sv-book-slides',4200);
})();
